import _ from "lodash";
import moment from "moment";
import Kichiri from "./KichiriService";
import UserService from "./UserService";
import toast from "react-hot-toast";

const UtilityService = {
	/**
	 * Simple Timeout promise
	 *
	 * @param {Number} ms
	 * @return {Promise}
	 */
	timeout: function(ms) {
		return new Promise(function(resolve, reject) {
			setTimeout(resolve, ms);
		});
	},

	async submitTicket({ name, description }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.support.create({ name, description }, {}, authToken);

			console.log(response);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	getOrdinal(n) {
		var s = ["th", "st", "nd", "rd"];
		var v = n % 100;
		return n + (s[(v - 20) % 10] || s[v] || s[0]);
	},

	/**
	 *
	 * @param {unknown} value
	 * @returns {boolean}
	 */
	isNullish: value => _.isNil(value),

	/**
	 *
	 * @param {unknown} value
	 * @returns {boolean}
	 */
	isNotNullish: value => !_.isNil(value),

	/**
	 * Get the relative dates for message dividers
	 *
	 * @param {Date} date
	 */
	getRelativeDate(date) {
		let momentDate = moment(date);

		if (momentDate.year() !== moment().year()) {
			return momentDate.format("ddd, MMM Do, YYYY");
		}

		return momentDate.calendar(null, {
			sameDay: "[Today]",
			nextDay: "[Tomorrow]",
			nextWeek: "dddd",
			lastDay: "[Yesterday]",
			lastWeek: "ddd, MMM Do",
			sameElse: "ddd, MMM Do"
		});
	},

	/*
	 * Returns a boolean whether or not container is empty
	 * @param {unknown} value
	 * @returns {boolean}
	 */
	isEmpty: value => _.isEmpty(value),

	/**
	 *
	 * @param {object} object
	 * @param {string} path
	 * @returns
	 */
	isPathFoundInObject: (object, path) => _.hasIn(object, path),

	/**
	 *
	 * @param {any} value
	 * @param {any} defaultValue
	 * @returns {any}
	 */
	defaultTo: ({ value, defaultValue }) => _.defaultTo(value, defaultValue),

	/**
	 * @description Safetly derives the property from object otherwise defaults to undefined, similar to ?. chaning operator in newer versions of JS
	 * @param {object} object
	 * @param {string} path
	 * @returns {any}
	 */
	getPropertyFromObject: ({ object, path }) => _.get(object, path),

	/**
	 * @description Create a deep copy of an object
	 * @param {Object} object
	 * @returns {Object}
	 */
	deepCopy: object => _.cloneDeep(object),

	/**
	 * @description Returns a boolean whether or not the text is in email format
	 * @param {object} param
	 * @param {string} param.text
	 * @returns {boolean} true if text is in email format
	 */
	isTextInEmailFormat: ({ text }) => {
		const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailPattern.test(text);
	},

	/**
	 * Validates the budget format to ensure it follows the "1h 30m" or "1h" or "30m" pattern.
	 *
	 * @param {string} budget - The budget string to validate.
	 * @returns {boolean} - Returns true if the format is valid, otherwise false.
	 */
	validateBudgetFormat: budget => {
		return budget.split(" ").every(part => {
			const num = parseInt(part);
			return (part.endsWith("h") && !isNaN(num)) || (part.endsWith("m") && !isNaN(num));
		});
	},

	/**
	 * @description Replacer function for notes/references
	 * @param {boolean} capitalizeFirstLetter - Flag to capitalize the first letter of the note type.
	 * @param {string} type - The type of note, either "reference" or "note".
	 * @returns {string} - The formatted note type, potentially capitalized.
	 */
	getNoteType: ({ capitalizeFirstLetter, type }) => {
		let typeToReturn = type === "reference" ? "reference" : "note";
		// Capitalize if 'capitalizeFirstLetter' flag is set to true
		return capitalizeFirstLetter ? typeToReturn.charAt(0).toUpperCase() + typeToReturn.slice(1) : typeToReturn;
	},

	/**
	 * Displays an alert with the specified type, message, and configuration.
	 *
	 * @param {Object} options - Configuration options for the alert.
	 * @param {string} options.type - The type of alert (e.g., "success", "error", "info", "warning").
	 * @param {string} options.text - The message to display in the alert.
	 * @param {string} [options.id] - A unique identifier for the alert (optional).
	 * @param {number} [options.timeout] - The time in milliseconds before the alert automatically dismisses (optional).
	 *
	 * @returns {void}
	 */
	alert: ({ type, text, id, timeout }) => {
		try {
			if (type === "dismiss" && id) {
				return toast.dismiss(id);
			}

			if (type === "info") {
				// Custom 'info' toast styling and icon
				return toast(text, {
					icon: "ℹ️",
					style: {
						background: "#fff", // white background
						color: "var(--primary-color)", // primary text color
						fontWeight: 700
					}
				});
			}

			// Handle success, error, or other types
			return toast[type](text, { timeout });
		} catch (error) {
			console.error(error);
		}
	},

	/**
	 * Validates the budget format to ensure it follows the "1h 30m" or "1h" or "30m" pattern.
	 *
	 * @param {string} budget - The budget string to validate.
	 * @returns {boolean} - Returns true if the format is valid, otherwise false.
	 */
	validateBudgetFormat: budget => {
		return budget.split(" ").every(part => {
			const num = parseInt(part);
			return (part.endsWith("h") && !isNaN(num)) || (part.endsWith("m") && !isNaN(num));
		});
	},

	/**
	 * @description Replacer function for notes/references
	 * @param {boolean} capitalizeFirstLetter - Flag to capitalize the first letter of the note type.
	 * @param {string} type - The type of note, either "reference" or "note".
	 * @returns {string} - The formatted note type, potentially capitalized.
	 */
	getNoteType: ({ capitalizeFirstLetter, type }) => {
		let typeToReturn = type === "reference" ? "reference" : "note";
		// Capitalize if 'capitalizeFirstLetter' flag is set to true
		return capitalizeFirstLetter ? typeToReturn.charAt(0).toUpperCase() + typeToReturn.slice(1) : typeToReturn;
	},

	/**
	 * Displays an alert with the specified type, message, and configuration.
	 *
	 * @param {Object} options - Configuration options for the alert.
	 * @param {string} options.type - The type of alert (e.g., "success", "error", "info", "warning").
	 * @param {string} options.text - The message to display in the alert.
	 * @param {string} [options.id] - A unique identifier for the alert (optional).
	 * @param {number} [options.timeout] - The time in milliseconds before the alert automatically dismisses (optional).
	 *
	 * @returns {void}
	 */
	alert: ({ type, text, id, timeout }) => {
		try {
			if (type === "dismiss" && id) {
				return toast.dismiss(id);
			}

			if (type === "info") {
				// Custom 'info' toast styling and icon
				return toast(text, {
					icon: "ℹ️",
					style: {
						background: "#fff", // white background
						color: "var(--primary-color)", // primary text color
						fontWeight: 700
					}
				});
			}

			// Handle success, error, or other types
			return toast[type](text, { timeout });
		} catch (error) {
			console.error(error);
		}
	},

	/**
	 * Initiates a download of a file represented by a blob.
	 *
	 * This function creates a temporary anchor (`<a>`) element, sets its `href` attribute to an object URL representing the blob,
	 * and sets the `download` attribute to the provided filename. It then programmatically clicks the anchor to trigger the download.
	 * After the download is initiated, the function cleans up by removing the anchor from the document and revoking the object URL to release memory.
	 *
	 * @param {Object} params - The parameters object.
	 * @param {Blob} params.blob - The blob representing the file to be downloaded.
	 * @param {string} params.fileName - The name of the file to be downloaded.
	 */
	downloadFile({ blob, fileName }) {
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");

		a.href = url;
		a.target = "_blank";
		a.download = fileName;
		document.body.appendChild(a);
		a.click();
		a.remove();

		// Clean up the URL object
		window.URL.revokeObjectURL(url);
	},
	isNotAllowedResource : ({response}) => {
		if (response &&  response.error && response.error.code === 403) {
			return true;
		}
		return false;
	},
	/**
	 * Converts any supported date-like input into a **date-only** string in `YYYY-MM-DD` format.
	 *
	 * Why this exists:
	 * - Normalizes dates across the app so APIs / filters / UI comparisons don’t get thrown off by time zones or time parts.
	 *
	 * What it accepts:
	 * - `null` / `undefined` / empty → returns `null`
	 * - A string already in `YYYY-MM-DD` → returns it unchanged (strict validation)
	 * - Anything Moment can parse (Date object, ISO string, etc.) → returns the date portion as `YYYY-MM-DD`
	 *
	 * Safety behavior:
	 * - If the value cannot be parsed into a valid date, returns `null` (instead of throwing).
	 *
	 * @param {any} params.value - Date-like value (string/Date/etc.)
	 * @returns {string|null} Date-only string in `YYYY-MM-DD`, or null if invalid.
	 */
	toDateOnly: ({value}) => {
		if (!value) return null;

		// If it's already "YYYY-MM-DD", keep it exactly (strict parse)
		if (typeof value === "string") {
			const strict = moment(value, "YYYY-MM-DD", true);
			if (strict.isValid()) return strict.format("YYYY-MM-DD");
		}

		// Otherwise, try normal moment parsing (handles Date objects, other strings, etc.)
		const parsed = moment(value);
		if (!parsed.isValid()) return null;

		return parsed.format("YYYY-MM-DD");
	},
};

export default UtilityService;
